"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Content = _interopRequireDefault(require("./Content"));

var _connectToScroller = _interopRequireDefault(require("../connectToScroller"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TranscriptTextView = /*#__PURE__*/function (_Component) {
  _inheritsLoose(TranscriptTextView, _Component);

  function TranscriptTextView(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "setScrollRef", function (element) {
      _this._scrollRef = element;
    });

    _this._scrollRef = /*#__PURE__*/_react["default"].createRef();
    return _this;
  }

  var _proto = TranscriptTextView.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateScrollHeight();
  };

  _proto.componentDidUpdate = function componentDidUpdate(nextProps) {
    this.updateScrollHeight(nextProps);
  };

  _proto.updateScrollHeight = function updateScrollHeight(pProps) {
    var props = pProps || this.props;

    if (this._scrollRef) {
      if (props.setScrollRef) {
        props.setScrollRef(this._scrollRef); // a lot of knockabout with scroll ref?
      }
    }
  };

  _proto.render = function render() {
    return /*#__PURE__*/_react["default"].createElement("article", {
      ref: this.setScrollRef.bind(this),
      className: "transcript-data"
    }, /*#__PURE__*/_react["default"].createElement(_Content["default"], this.props));
  };

  return TranscriptTextView;
}(_react.Component);

var _default = (0, _connectToScroller["default"])(TranscriptTextView);

exports["default"] = _default;